// extracted by mini-css-extract-plugin
export var underlinedLink = "_sp-0";